import { ReactNode } from "react";
import { Box, BoxProps, Grid2 } from "@mui/material";
import { useDimensions } from "../../../hooks";

interface ContainerProps {
  children: ReactNode;
  sx?: React.CSSProperties;
  bordered?: boolean;
  height?: string;
}

const Container = ({
  children,
  bordered = false,
  sx = {},
  height = undefined,
  ...rest
}: ContainerProps & BoxProps) => {
  const { isSmall } = useDimensions();

  return (
    <Grid2 container justifyContent="center">
      <Box
        sx={[
          {
            width: isSmall ? "100%" : "80vw",
            height: height ?? isSmall ? "unset" : "35vh",
            margin: {
              sm: "1px",
              md: "10px",
              lg: "2vh",
            },

            marginBottom: {
              sm: "1px",
              md: "10px",
              lg: "18vh",
            },
            paddingBottom: "20px",
            backgroundColor: "white",
            overflowX: "hidden",
            zIndex: 10,
          },

          sx,
        ]}
        border={bordered ? "1px solid #BFC0C0" : ""}
        {...rest}
      >
        {children}
      </Box>
    </Grid2>
  );
};

export default Container;
